export const getFirstErrorPath = (errors, prefix = "") => {
  if (!errors) return "";
  if (typeof errors === "string") return prefix;

  if (Array.isArray(errors)) {
    for (let index = 0; index < errors.length; index += 1) {
      const path = getFirstErrorPath(
        errors[index],
        prefix ? `${prefix}.${index}` : String(index),
      );
      if (path) return path;
    }
    return "";
  }

  if (typeof errors === "object") {
    for (const key of Object.keys(errors)) {
      const path = getFirstErrorPath(
        errors[key],
        prefix ? `${prefix}.${key}` : key,
      );
      if (path) return path;
    }
  }

  return "";
};

const getFocusableField = (fieldPath, aliases = {}) => {
  const names = [fieldPath, aliases[fieldPath]].filter(Boolean);
  const fields = Array.from(
    document.querySelectorAll(
      "input, textarea, select, button, [role='combobox'], [tabindex]",
    ),
  );

  return fields.find((field) =>
    names.some(
      (name) =>
        field.getAttribute("name") === name ||
        field.getAttribute("id") === name ||
        field.getAttribute("data-field-name") === name,
    ),
  );
};

export const focusFirstError = (fieldPath, options = {}) => {
  if (!fieldPath || typeof document === "undefined") return;

  window.setTimeout(() => {
    const field = getFocusableField(fieldPath, options.aliases);
    if (!field) return;

    const scrollTarget = options.sectionSelector
      ? field.closest(options.sectionSelector) || field
      : field;
    scrollTarget.scrollIntoView({
      behavior: "smooth",
      block: "center",
    });

    window.setTimeout(() => {
      field.focus?.({ preventScroll: true });
    }, 250);
  }, options.delay ?? 80);
};
